// Local-storage helpers for the interview module. The D1 row is the source
// of truth; these helpers only manage the active session id (so the user
// resumes mid-session after a refresh) and a per-session "last seen question
// id" used by the clarify button to know which question to clarify.

const LAST_QUESTION_KEY = 'scalent-interview-last-question';

export function saveLastQuestionId(sessionId: string, questionId: string | null): void {
  try {
    if (questionId) {
      localStorage.setItem(`${LAST_QUESTION_KEY}-${sessionId}`, questionId);
    } else {
      localStorage.removeItem(`${LAST_QUESTION_KEY}-${sessionId}`);
    }
  } catch {
    /* localStorage unavailable */
  }
}

export function loadLastQuestionId(sessionId: string): string | null {
  try {
    return localStorage.getItem(`${LAST_QUESTION_KEY}-${sessionId}`);
  } catch {
    return null;
  }
}
